import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { BaseDataService } from './base.data.service';
import { Injectable } from '@angular/core';
import { IJobUnassignedReason, IJobUnassignedReasonSearch } from '../interfaces/job-assignment';

@Injectable({
  providedIn: 'root',
})
export class JobUnassignedReasonService extends BaseDataService {
  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  entityTitle: string = 'Reason';

  getReasons(search?: IJobUnassignedReasonSearch): Promise<IJobUnassignedReason[]> {
    const url = '/api/job/unassignedReasons';

    let myObject = {};

    if (search != null) {
      myObject = JSON.parse(JSON.stringify(search));
    }

    let params = new HttpParams({ fromObject: myObject });

    return this.handleRequest<any[]>(
      this.http.get<IJobUnassignedReason[]>(url, { params: params }),
      this.handlersFactory.getForReadAll(),
    );
  }

  createReason(dto: IJobUnassignedReason) {
    const url = '/api/job/unassignedReason';

    return this.handleRequest<any[]>(
      this.http.post<IJobUnassignedReason[]>(url, dto),
      this.handlersFactory.getForCreate(this.entityTitle),
    );
  }

  patchReason(id: number, patch: any) {
    const url = '/api/job/unassignedReason/' + id;

    return this.handleRequest<any[]>(
      this.http.patch<IJobUnassignedReason[]>(url, patch),
      this.handlersFactory.getForReadAll(),
    );
  }
}
